var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-button-container",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"icon"},[_vm._t("default")],2),_c('div',{staticClass:"text"},[_c('span',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }